import { REACT_APP_API_URL } from '../Components/processENV';
import { getFromLocalStorageAndDecrypt } from '../Components/WebChat/WebChatEncryptDecrypt';
import { WALLPAPER_COLOR_CODES } from '../Helpers/Constants';
import { post } from './http';

/**
 * Persist the chat wallpaper for the current user.
 *
 * @param {string} [wallpaperColor] Hex colour; falls back to the default.
 * @param {string} [image] Wallpaper image URL, when one is set.
 * @returns {Promise<any>} The API payload.
 * @throws {HttpError} When credentials are missing or the request fails.
 */
export const saveWallpaper = (wallpaperColor, image) => {
    const authUser = getFromLocalStorageAndDecrypt('auth_user');

    return post(
        `${REACT_APP_API_URL}/users/chatBackground`,
        [
            {
                username: String(authUser?.username ?? ''),
                chatUser: '',
                chatType: 'default',
                platform: 'web',
                deviceId: '',
                themeColorHex: wallpaperColor || WALLPAPER_COLOR_CODES[0],
                imageUrl: image || '',
                fileToken: '',
            },
        ],
        { auth: true },
    );
};
